export default "__VITE_ASSET__D$PkwvgY__"